import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ArrayEditCell } from "./Cells/ArrayEditCell";
import { CheckboxEditCell } from "./Cells/CheckboxCell";
import { TextEditCell } from "./Cells/TextEditCell";
import { TextPreviewCell } from "./Cells/TextPreviewCell";

export function TableEditItem({ columns, values, isnew = false, functions }) {
  const [localValues, setLocalValues] = useState(isnew ? dafaultFromColumns(columns) : values);
  const { t } = useTranslation();
  let tempValue = { ...localValues };
  const getValue = (path, obj) =>
    path?.split(".").reduce((acc, c) => acc && acc[c], obj) ?? undefined;

  function setObjectProperty(object, path, value) {
    let result = object;
    const parts = path.split(".");
    const limit = parts.length - 1;
    for (let i = 0; i < limit; ++i) {
      const key = parts[i];
      object = object[key] ?? (object[key] = {});
    }
    const key = parts[limit];
    object[key] = value;
    return result;
  }

  function dafaultFromColumns(columns) {
    let result = {};

    columns?.map((item, index) => {
      if (item.visible ?? true) {
        result = setObjectProperty(
          result,
          item.path,
          item?.type === "array"
            ? []
            : item.type === "boolean"
              ? false
              : item.type === "checkbox"
                ? false
                : ""
        );
      }
    });
    return result;
  }
  useEffect(() => {
    functions?.handleSave(localValues);
  }, [localValues]);
  return (
    <>
      {columns.map((column, index) => {
        if (!(column.visible ?? true) || column.filtered) return null;
        if (column.type === "array") {
          return (
            <ArrayEditCell
              key={index}
              value={isnew ? [] : ((localValues && getValue(column.path, localValues)) ?? [])}
              onChangeValue={(e) => {
                setObjectProperty(tempValue, column.path, e);
                setLocalValues(tempValue);
              }}
            />
          );
        }
        if (column.type === "checkbox") {
          return (
            <CheckboxEditCell
              key={index}
              value={getValue(column.path, localValues) ?? []}
              onChangeValue={(e) => {
                setObjectProperty(tempValue, column.path, e);
                setLocalValues(tempValue);
              }}
            />
          );
        }
        return column.disabled ? (
          <TextPreviewCell
            key={index}
            value={getValue(column.path, localValues) ?? ""}
            // onChangeValue={(e) => {
            //   setObjectProperty(tempValue, column.path, e);
            //   setLocalValues(tempValue);
            // }}
            // infotext={
            //   column.infotext != undefined
            //     ? t(column.infotext, { ns: column?.translationNamespace })
            //     : undefined
            // }
            // type={column.type ?? undefined}
            // valueType={column.valuetype ?? undefined}
          />
        ) : (
          <TextEditCell
            key={index}
            value={getValue(column.path, localValues) ?? ""}
            onChangeValue={(e) => {
              setObjectProperty(tempValue, column.path, e);
              setLocalValues(tempValue);
            }}
            infotext={
              column.infotext != undefined
                ? t(column.infotext, { ns: column?.translationNamespace })
                : undefined
            }
            type={column.type ?? undefined}
            valueType={column.valuetype ?? undefined}
          />
        );
      })}
    </>
  );
}
